<template>
    <article class="type-info" :id="`type-${type.name}`">
        <header class="type-info-header">
            <h3 class="type-info-title">{{ type.name }}</h3>
            <markdown class="type-info-description">{{ type.description }}</markdown>
        </header>
        <div class="type-info-inner">
            <type-properties v-if="type.entity" class="entity-properties" :properties="type.properties"/>
            <aside v-if="type.entity" class="entity-sample">
                <header class="entity-sample-header">
                    <h4 class="entity-sample-title">Example</h4>
                </header>
                <code-block language="json" :code="entitySample"/>
            </aside>
        </div>
    </article>
</template>

<!--suppress JSValidateTypes -->
<script>
  import Markdown       from 'vue-markdown-v2';
  import Type           from '../../modules/Elements/Type';
  import CodeBlock      from '../CodeBlock';
  import TypeProperties from './TypeProperties';

  export default {
    name:       'TypeInfo',
    components: {
      TypeProperties,
      CodeBlock,
      Markdown,
    },

    props: {

      /**
       * @var {Type}
       */
      type: {
        type:     Type,
        required: true,
      },
    },

    data () {
      return {};
    },

    computed: {
      entitySample () {
        if ( !this.type.entity ) {
          return '';
        }

        return JSON.stringify(Object.values(this.type.properties).reduce(( json, property ) => {
          const value = property.example || property.default || '';
          const type  = property.types[ 0 ];

          json[ property.name ] = type.stringifyValue(value);
          return json;
        }, {}), null, 4);
      },
    },

    methods: {},
  };
</script>

<style scoped>
    .type-info + .type-info {
        margin-top:  3rem;
        padding-top: 3rem;
        border-top:  1px solid var(--color-gray-light);
    }

    .type-info-inner {
        display: flex;
    }

    .entity-properties {
        flex:         1 0 auto;
        margin-right: 2rem;
    }

    .entity-sample {
        min-width: 25vw;
        max-width: 50vw;
    }

    .type-info-title {
        margin-bottom: 0;
    }

    .type-info-description >>> p {
        margin: 0;
    }
</style>
